import { defineStore } from 'pinia';
import Cookies from 'js-cookie';
import { UserInfosStates } from './interface';
import { Local } from '/@/utils/storage';
import { useLoginApi } from '../api/login';

/**
 * 用户信息
 * @methods setUserInfos 设置用户信息
 */
export const useUserInfo = defineStore('userInfo', {
    state: (): UserInfosStates => ({
        userInfos: {
            userName: '',
            time: 0,
            roles: [],
            roleType: '',
            permissionList: [],
            customer: {},
            tenant: {}
        },
    }),
    actions: {
        async setUserInfos() {
            const userInfos: any = await this.getApiUserInfo();
            this.userInfos = userInfos;
        },
        // 模拟接口数据
        // https://gitee.com/lyt-top/vue-next-admin/issues/I5F1HP
        async getApiUserInfo() {
            return useLoginApi()
                .GetUserInfo({})
                .then((res) => {
                    const userInfos = {
                        userName: res.data.nickName,
                        time: new Date().getTime(),
                        roles: [],
                        roleType: res.data.roleType,
                        permissionList: res.data.permissionList,
                        customer: res.data.customer,
                        tenant: res.data.tenant,
                    };
                    return userInfos;
                })
                .catch();
        },
    },
});